<div class="header">
    <div class="header--title">Filter</div>
    <div class="header--sub-title">Næringssalg</div>
    <!-- <div class="header--reset" (click)="resetFilter()">Nullstill</div> -->
    <div class="header--close" (click)="closeFilter()"></div>
</div>
<div class="content">
    <form [formGroup]="form">
        <ev-accordion [initExpanded]="true">
            <div header class="accordion--title">Eiendomstyper</div>
            <div body class="accordion--body">
                @if(commercialSubTypeResource.isLoading()){
                <div class="multiselect-placeholder">loading...</div>
                }@else{
                <ev-multiselect-dropdown-v2
                    formControlName="commercialSubTypes"
                    [alternatives]="commercialSubTypeResource.value()"
                    title="Næring"
                    [treatNullAsAll]="false"
                ></ev-multiselect-dropdown-v2>
                } @if(agriculturalSubTypeResource.isLoading()){
                <div class="multiselect-placeholder">loading...</div>
                }@else{
                <ev-multiselect-dropdown-v2
                    formControlName="agriculturalSubTypes"
                    [alternatives]="agriculturalSubTypeResource.value()"
                    title="Landbruk"
                    [treatNullAsAll]="false"
                ></ev-multiselect-dropdown-v2>
                } @if(otherEstateTypesResource.isLoading()){
                <div class="multiselect-placeholder">loading...</div>
                }@else{
                <ev-multiselect-dropdown-v2
                    formControlName="otherEstateTypes"
                    [alternatives]="otherEstateTypesResource.value()"
                    title="Andre"
                    [treatNullAsAll]="false"
                ></ev-multiselect-dropdown-v2>
                }
            </div>
        </ev-accordion>
    </form>
    <ev-accordion>
        <div header class="accordion--title">Tidsperiode</div>
        <div body class="filter-component-padding">
            <time-period [reset]="reset" [toDateFormControl]="form.controls.toDate" [fromDateFormControl]="form.controls.since"> </time-period>
        </div>
    </ev-accordion>
</div>
